import "../../assets/css/subscribe.scss";
import Header from "../../components/header";
import NewsFooter from "../../components/news_footer";

import imageCrew from "../../assets/images/news/crew.png";
import { useSearchParams } from "react-router-dom";
import { useDonationModal } from "../../hooks/use_donation_modal";
import DonationModalContainer from "../../components/modal/donate_modal_container";
import { useSubSalesValidation } from "../../hooks/use_sub_sales_validation";

function ProductPage() {
  const [searchParams] = useSearchParams();
  const kdBusiness = searchParams.get("kd_business");
  const userRef = searchParams.get("usridx");

  const donationModal = useDonationModal();

  useSubSalesValidation(kdBusiness);

  return (
    <div className="subscribe-body">
      <Header variant="subpage" />

      <section className="sub-page-section">
        <div className="sub-container">
          <div className="sub-page-header">
            <h1 className="sub-page-title">구독권 선택</h1>
            <p className="sub-page-subtitle">
              키즈다의 모든 기능을 자유롭게 이용해보세요
            </p>
          </div>

          {/* 구독권 카드 */}
          <div className="sub-grid">
            {/* 1개월 */}
            <div className="sub-card">
              <div className="sub-card-body">
                <span className="sub-badge">1개월</span>
                <div className="sub-price">
                  10,000<span className="sub-price-unit">원</span>
                </div>
                <div className="sub-period">월 결제</div>
                <div className="sub-divider"></div>
                <ul className="sub-features">
                  <li>
                    <i className="fas fa-check"></i>모든 뉴스 콘텐츠 무제한
                  </li>
                  <li>
                    <i className="fas fa-check"></i>AI 학습 리포트
                  </li>
                  <li>
                    <i className="fas fa-check"></i>퀴즈 &amp; 요약 기능
                  </li>
                  <li>
                    <i className="fas fa-check"></i>부모 대시보드
                  </li>
                </ul>
                <button
                  className="sub-btn"
                  onClick={() => donationModal.startDonationProcess("1")}
                >
                  결제하기
                </button>
              </div>
            </div>

            {/* 3개월 */}
            <div className="sub-card">
              <div className="sub-card-body">
                <span className="sub-badge sub-badge--pro">3개월</span>
                <div className="sub-price">
                  30,000<span className="sub-price-unit">원</span>
                </div>
                <div className="sub-period">분기 결제</div>
                <div className="sub-divider"></div>
                <ul className="sub-features">
                  <li>
                    <i className="fas fa-check"></i>1개월 플랜의 모든 기능
                  </li>
                  <li>
                    <i className="fas fa-check"></i>AI 학습 리포트
                  </li>
                  <li>
                    <i className="fas fa-check"></i>퀴즈 &amp; 요약 기능
                  </li>
                  <li>
                    <i className="fas fa-check"></i>부모 대시보드
                  </li>
                </ul>
                <button
                  className="sub-btn"
                  onClick={() => donationModal.startDonationProcess("2")}
                >
                  결제하기
                </button>
              </div>
            </div>

            {/* 12개월 (추천) */}
            <div className="sub-card sub-card--featured">
              <div className="sub-card-body">
                <span className="sub-badge sub-badge--annual">
                  12개월 · 추천
                </span>
                <div className="sub-price-original">120,000원</div>
                <div className="sub-price">
                  108,000<span className="sub-price-unit">원</span>
                </div>
                <div className="sub-period">
                  연 결제 <span className="sub-discount">10% 할인</span>
                </div>
                <div className="sub-divider"></div>
                <ul className="sub-features">
                  <li>
                    <i className="fas fa-check"></i>3개월 플랜의 모든 기능
                  </li>
                  <li>
                    <i className="fas fa-check"></i>AI 학습 리포트
                  </li>
                  <li>
                    <i className="fas fa-check"></i>퀴즈 &amp; 요약 기능
                  </li>
                  <li>
                    <i className="fas fa-check"></i>
                    <strong>월 9,000원</strong> (12개월)
                  </li>
                </ul>
                <button
                  className="sub-btn sub-btn--featured"
                  onClick={() => donationModal.startDonationProcess("4")}
                >
                  결제하기
                </button>
              </div>
            </div>
          </div>

          {/* NIE 기부 캠페인 */}
          <div className="nie-section">
            <div className="nie-header">
              <h2 className="nie-title">NIE 기부 캠페인</h2>
              <p className="nie-subtitle">모든 아이에게 동등한 학습 기회를</p>
            </div>
            <div className="nie-grid">
              <div className="nie-intro">
                <div className="nie-intro-text">
                  <span className="nie-badge">함께 만드는 교육 나눔</span>
                  <h3 className="nie-intro-title">NIE 기부 캠페인 소개</h3>
                  <p className="nie-intro-desc">
                    NIE(Newspaper In Education)는 아이들이 뉴스를 통해 세상을
                    이해하고 비판적 사고를 기를 수 있도록 돕는 교육
                    프로그램입니다. 키즈다는 모두가 동등하게 학습 기회를 누릴 수
                    있도록 구독권을 나눕니다.
                  </p>
                </div>
                <div className="nie-visual">
                  <img src={imageCrew} alt="신문 읽는 어린이 일러스트" />
                </div>
              </div>
              <div className="nie-donate">
                <h3 className="nie-donate-title">NIE 기부 참여하기</h3>
                <p className="nie-donate-desc">
                  보유 포인트를 기부하거나, 직접 결제로 아이들의 학습을 후원할
                  수 있습니다.
                </p>
                <button
                  className="sub-btn sub-btn--donate"
                  onClick={() => donationModal.startDonationProcess("0")}
                >
                  기부하기
                </button>
              </div>
            </div>
          </div>

          {/* 유의사항 */}
          <div className="sub-notice-section">
            <div className="sub-notice-card">
              <h3 className="sub-notice-title">서비스 이용 유의사항</h3>
              <ul className="sub-notice-list">
                <li>상기금액은 부가세 포함된 금액입니다.</li>
                <li>
                  구입하신 구독권은 결제내역 페이지에서 확인할 수 있습니다.{" "}
                  <a href="/product_step1" className="sub-notice-link">
                    결제내역 바로가기
                  </a>
                </li>
                <li>
                  기부내역은 기부내역 페이지에서 확인할 수 있습니다.{" "}
                  <a href="/donation_step1" className="sub-notice-link">
                    기부내역 바로가기
                  </a>
                </li>
                <li>
                  결제 완료 시 인증하신 휴대폰번호로 즉시 구독권이 발송됩니다.
                </li>
                <li>
                  구입하신 구독권은 어린이동아 앱내 'My &gt; 쿠폰 등록'
                  페이지에서 사용할 수 있습니다.
                </li>
                <li>
                  유료 구독 서비스 특성상, 이미 제공된 콘텐츠에 대해서는 환불이
                  제한될 수 있습니다.
                  <br />
                  환불은 고객의 신청일 기준 이용 여부 및 남은 기간을 고려하여
                  합리적으로 산정됩니다.
                  <br />
                  결제일 기준 초기 일정 기간내 환불요청이 있을 경우, 콘텐츠
                  미이용 시 전액 환불을 원칙으로 합니다.
                  <br />
                  환불시 평가기준 월 단위 사용료를 차감한 후 잔여 금액을
                  반환합니다. (할인 금액은 환불 대상에서 제외)
                  <br />
                  <a href="/application/service" className="sub-notice-link">
                    환불정책 바로가기
                  </a>{" "}
                  자세한 환불정책을 확인하실 수 있습니다.
                </li>
                <li>
                  유료 사용자에게 제공된 기능은 이용 기간만료 후에는 사용할 수
                  없습니다.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <NewsFooter />

      <DonationModalContainer
        {...donationModal}
        kdBusiness={kdBusiness}
        userRef={userRef}
        paymentType="card"
      />
    </div>
  );
}

export default ProductPage;
